import React from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect
} from 'react-router-dom';
import APP from '../modules';
import { checkUserLoginHoc } from '../hoc/checkUserLoginHoc';
import { routes } from './routes';

/*
Here you can map your component with the url you want to
*/

export default class Init extends React.Component {
  renderRoutes = () => {
    const { NOT_FOUND } = APP.Constants.ROUTES;

    return routes.map((item) => {
      return (
        <Route
          path={item.route}
          key={item.route}
          exact={item.exact}
          render={(props) => {
            const isAdmin = localStorage.getItem('role') === 'ADMIN';
            let pageSet;
            try {
              pageSet = JSON.parse(localStorage.getItem('pageSet'));
            } catch (e) {}
            if (!isAdmin) {
              if (item.isRoleCheck) {
                const isExist =
                  pageSet &&
                  pageSet.length &&
                  pageSet.find((pItem) => pItem.pageName === item.pageName);
                if (!isExist) return <Redirect to={NOT_FOUND} />;
              }
            }
            if (item.route === '/admin') {
              const isSuperAdmin =
                localStorage.getItem('role') === 'SUPERADMIN';
              if (!isSuperAdmin) return <Redirect to={NOT_FOUND} />;
            }
            // if (item.route === '/testdesign') {
            //   const isTestDesign =
            //     localStorage.getItem('TestDesign') === 'false';
            //   if (isTestDesign) return <Redirect to={NOT_FOUND} />;
            // }
            // if (item.route === '/testdatageneration') {
            //   const isTestData =
            //     localStorage.getItem('TestDataManagement') === 'false';
            //   if (isTestData) return <Redirect to={NOT_FOUND} />;
            // }
            // if (item.route === '/home') {
            //   const isTestHome =
            //     localStorage.getItem('TestDataManagement') === 'false' ||
            //     localStorage.getItem('TestDesign') === 'false';
            //   if (isTestHome) return <Redirect to={NOT_FOUND} />;
            // }
            const Component = checkUserLoginHoc(item.component);
            return <Component {...props} />;
          }}
        />
      );
    });
  };

  render() {
    const { NOT_FOUND } = APP.Constants.ROUTES;
    return (
      <Router>
        <Switch>
          {this.renderRoutes()}
          <Route
            path=''
            exact={false}
            render={() => {
              return <Redirect to={NOT_FOUND} />;
            }}
          />
        </Switch>
      </Router>
    );
  }
}
